// Single source of truth for the one-time logo export purchase and the export
// formats a buyer receives. The pricing pages, the logo detail page, the
// checkout route and the export route all read from here so the advertised
// price can never drift away from the amount actually charged.

export const LOGO_EXPORT_PRICE_CENTS = 700
export const LOGO_EXPORT_PRICE_LABEL = '$7'

export type ExportFormat = 'png' | 'svg' | 'pdf' | 'eps'

export const EXPORT_FORMATS: ExportFormat[] = ['png', 'svg', 'pdf', 'eps']

interface ExportFormatMeta {
    label: string
    description: string
    contentType: string
    extension: string
    // Raster formats are served straight from storage; vector formats are
    // traced on our own servers on first request and then cached.
    vector: boolean
}

export const EXPORT_FORMAT_META: Record<ExportFormat, ExportFormatMeta> = {
    png: {
        label: 'PNG',
        description: 'Full-resolution raster file for web and social',
        contentType: 'image/png',
        extension: 'png',
        vector: false
    },
    svg: {
        label: 'SVG',
        description: 'Scalable vector file for web and design tools',
        contentType: 'image/svg+xml',
        extension: 'svg',
        vector: true
    },
    pdf: {
        label: 'PDF',
        description: 'Print-ready vector document',
        contentType: 'application/pdf',
        extension: 'pdf',
        vector: true
    },
    eps: {
        label: 'EPS',
        description: 'Vector format for print shops and Illustrator',
        contentType: 'application/postscript',
        extension: 'eps',
        vector: true
    }
}

export function isExportFormat(value: string): value is ExportFormat {
    return (EXPORT_FORMATS as string[]).includes(value)
}
